/**
 * Created by Daniela on 30/01/2017.
 */
import { Component, OnInit } from '@angular/core';

import { BombaNavigationService } from "../shared/bomba-navigation.service";
import { BombaApiService } from "../shared/bomba-api.service";
import { Bomba } from "../shared/bomba.model";
import { bombasModuleName, bombasAuditoriaModuleName } from "../shared/data.service";
import { abastecimentosModuleName } from "../../shared/data.service";

@Component({
    template: require('./bomba-auditoria-list.component.html'),
    styles: [require('./bomba-auditoria-list.component.css')]
})
export class BombaAuditoriaListComponent implements OnInit {
    list: Bomba[] = [];
    loading: boolean = true;
    bombaModule: any = bombasModuleName;
    bombasAuditoriaModule: any = bombasAuditoriaModuleName;
    module: any = abastecimentosModuleName;

    constructor(
        private _bombaNavigationService: BombaNavigationService,
        private _bombasApiService: BombaApiService
    ) { }

    ngOnInit() {
        this.getAll();
    }

    clickDetail(item: Bomba) {
        this._bombaNavigationService.goToAuditoriaDetail(item.id);
    }

    private getAll() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._bombasApiService.onGetAll(onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/bombas/bomba-auditoria-list/bomba-auditoria-list.component.ts
 **/